import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    crudList: {
      displayRemoveAllRows: false,
      removeAllSelectedRows: false,
      selectedRowsForRemove: [],
    },
  },
  mutations: {
    handleCrudListRemove: (state) => {
      state.crudList.displayRemoveAllRows = !state.crudList.displayRemoveAllRows;
    },
    handleCrudListRemovedRows: (state, content) => {
      state.crudList.selectedRowsForRemove = content;
    },
  },
  actions: {
    handleDisplayRemovedCrudList: ({ commit }) => commit('handleCrudListRemove'),
    setRemovedCrudListRows: ({ commit }, content) => commit('handleCrudListRemovedRows', content),
  },
  getters: {
    getRemovedCrudListDisplayValue: (state) => state.crudList.displayRemoveAllRows,
  },
});

export default store;
